import { AddTreatmentRequestPayload } from "@/data/payload/treatment/add-treatment-request-payload";
import { AddTreatmentResponseEntity } from "@/domain/entity/treatment/add-treatment-response-entity";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class AddTreatmentUsecase {
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  async execute(
    payload: AddTreatmentRequestPayload,
  ): Promise<SATResult<AddTreatmentResponseEntity, SATError>> {
    return this.treatmentRepo.addTreatment(payload);
  }
}
